import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const FinalCTA = ({ onGetQuote }) => {
  return (
    <section className="final-cta-modern">
      <div className="final-cta-modern-container">
        <div className="final-cta-modern-content">
          <span className="section-label-modern white">START YOUR PROJECT</span>
          <h2 className="final-cta-modern-title">
            Ready to Manufacture Your Next Innovation?
          </h2>
          <p className="final-cta-modern-text">
            Submit your requirements today and our engineering team will connect with you within 24 hours.
          </p>
          <Button 
            className="primary-cta large-cta"
            onClick={onGetQuote}
          >
            Get Started Today
            <ArrowRight className="ml-2 h-6 w-6" />
          </Button>
        </div>
        <div className="final-cta-modern-image">
          <img 
            src="https://images.pexels.com/photos/30640195/pexels-photo-30640195.jpeg"
            alt="Manufacturing Excellence"
            className="cta-img"
          />
          <div className="cta-overlay"></div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
